module.exports = __webpack_public_path__ + "img/client14.67a6545a.png";